import { AxiosError } from "axios";

import { api } from "@/lib/axios";

export async function signOut(): Promise<
	{ status: "success" } | { status: "error"; errors: { [key: string]: string } }
> {
	try {
		await api.post("/auth/logout");

		return {
			status: "success",
		};
	} catch (error: unknown) {
		const axiosError = error as AxiosError<{
			errors: { [key: string]: string };
		}>;

		if (axiosError.response?.status === 401) {
			return {
				status: "error",
				errors: {
					email: "E-mail ou senha estão incorretos.",
					password: "E-mail ou senha estão incorretos.",
				},
			};
		}

		return {
			status: "error",
			errors: {
				unknown: "Erro desconhecido. Tente novamente mais tarde.",
			},
		};
	}
}
